
if (process.env.BROWSER === 'ff' || process.env.BROWSER === 'ie') {
  module.exports = require('./CustomScroll.scss');
} else {
  module.exports = '';
}
